import React, { useContext } from 'react';
import axios from 'axios';
import { Button } from '@brokerbay/design-components';

import {
  CHAT_SESSION_STORAGE_KEYS,
  isAssumeOrgType,
  isContextualChatEnabled,
} from 'utils';
import styled from 'styled-components';
import { UserRoles } from '@bb/users';
import { AnsweringSubscriptionTag } from '@bb/domain/dist/types';

import {
  UniversalSearchContext,
  CrossOrgAnsweringContext,
  AuthContext,
  ContextualChatContext,
} from 'contexts';

import { AnsweringServiceType } from '@bb/domain/dist/types/AnsweringSubscription';
import { SupraCoopType } from '@bb/domain/dist/types/SupraSystemSubscription';
import { useStartChat } from 'hooks';
import { NoWrapRow } from './StyledComponents';
import { Icon } from '../Icon';
import { addAgentToHistory } from '../../api/RecentSearchHistoryController';

type AgentRowActionsProps = {
  id: string;
  index: number;
  coopType?: SupraCoopType;
  role: UserRoles;
  subscriptionTag?:
    | AnsweringSubscriptionTag
    | Exclude<AnsweringServiceType, AnsweringServiceType.Legacy>;
  isMlsStaff?: boolean;
  enableChat?: boolean;
  isAppointmentDesk?: boolean;
};

const AgentRowActions: React.FC<AgentRowActionsProps> = ({
  id,
  index,
  coopType,
  subscriptionTag,
  isMlsStaff,
  enableChat,
  isAppointmentDesk,
}) => {
  const { activeRow } = useContext(UniversalSearchContext);
  const { answeringConfirm } = useContext(CrossOrgAnsweringContext);
  const { auth } = useContext(AuthContext);
  const { setChatModalVisible } = useContext(ContextualChatContext);
  const { startChat } = useStartChat();

  if (index !== activeRow) return null;

  return (
    <>
      <AgentNoWrapRow onClick={e => e.stopPropagation()}>
        {!isMlsStaff &&
          enableChat &&
          !isContextualChatEnabled(auth.org?.mlsTypes) && (
            <StyledButton
              type="default"
              icon={<Icon type="chatBubble" height={15} width={15} />}
              onClick={event => {
                event.stopPropagation();

                answeringConfirm({ type: 'agent', subscriptionTag }, () => {
                  addAgentToHistory(id);
                  axios.post('/messaging/newConvo', { userIds: [id] });
                })();
              }}
              data-cy="agent-chat-button"
            >
              Chat
            </StyledButton>
          )}
        {!isMlsStaff &&
          enableChat &&
          isContextualChatEnabled(auth.org?.mlsTypes) && (
            <StyledButton
              type="default"
              icon={<Icon type="chatBubble" height={15} width={15} />}
              onClick={event => {
                event.stopPropagation();

                answeringConfirm({ type: 'agent', subscriptionTag }, () => {
                  addAgentToHistory(id);
                  setChatModalVisible(true);
                  startChat({
                    userId: auth.streamChatId,
                    selectedUsers: [{ id, bbUserId: id }],
                  });
                })();
              }}
              data-cy="agent-chat-button"
            >
              Chat
            </StyledButton>
          )}
        {(isAssumeOrgType(auth.org.type) || isMlsStaff) &&
          isAppointmentDesk &&
          coopType === SupraCoopType.PRIMARY && (
            <StyledButton
              icon={<Icon type="antdLoginOutlined" height={15} width={15} />}
              onClick={event => {
                event.stopPropagation();

                answeringConfirm({ type: 'agent', subscriptionTag }, () => {
                  CHAT_SESSION_STORAGE_KEYS.forEach(key =>
                    sessionStorage.removeItem(key),
                  );
                  window.location.href = `/answering/assume_user/${id}`;
                })();
              }}
              data-cy="agent-assume-button"
            >
              Assume
            </StyledButton>
          )}
      </AgentNoWrapRow>
    </>
  );
};

const StyledButton = styled(Button)`
  margin-left: 0.5rem;
`;

export const AgentNoWrapRow = styled(NoWrapRow)`
  justify-content: flex-end;
`;

export default AgentRowActions;
